/**
 * OPUS-913 — Modal shell (ported from the Claude Design handoff primitives.jsx).
 * Centered dialog over a blurred scrim; header (optional icon + title + subtitle
 * + close), scrollable body, optional right-aligned footer (ghost Cancel → green
 * primary). Esc + backdrop close.
 */
import React, { useEffect } from "react";
import { Icon } from "./Icon";
import { IconButton } from "./Button";

export function Modal({ open, onClose, title, subtitle, children, footer, width = 540, icon, centered = false }) {
  useEffect(() => {
    function onKey(e) { if (e.key === "Escape") onClose && onClose(); }
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div onMouseDown={onClose} style={{
      position: "fixed", inset: 0, zIndex: 1300, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(3px)",
      display: "flex", alignItems: centered ? "center" : "flex-start", justifyContent: "center",
      padding: centered ? 20 : "7vh 20px 20px", animation: "opusFade .15s ease",
    }}>
      <div onMouseDown={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={title} style={{
        width: "100%", maxWidth: width, background: "var(--elevated)", border: "1px solid var(--border-strong)",
        borderRadius: "var(--r-lg)", boxShadow: "var(--shadow-lg)", overflow: "hidden",
        animation: "opusPop .18s cubic-bezier(.2,.8,.3,1)", maxHeight: "86vh", display: "flex", flexDirection: "column",
      }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: 13, padding: "20px 22px", borderBottom: "1px solid var(--border)" }}>
          {icon && (
            <div style={{ width: 38, height: 38, borderRadius: "var(--r-md)", background: "rgba(255,69,92,0.12)", color: "var(--coral)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon name={icon} size={19} />
            </div>
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.01em", margin: 0 }}>{title}</h2>
            {subtitle && <p style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 3, marginBottom: 0 }}>{subtitle}</p>}
          </div>
          {onClose && <IconButton icon="x" title="Close" onClick={onClose} />}
        </div>
        <div className="opus-scroll" style={{ padding: 22, overflowY: "auto", flex: 1 }}>{children}</div>
        {footer && (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "16px 22px", borderTop: "1px solid var(--border)", background: "var(--surface-0)" }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

export default Modal;
